import { render, staticRenderFns } from "./FullPageTermsForm.vue?vue&type=template&id=bf797f16&"
import script from "./FullPageTermsForm.vue?vue&type=script&lang=js&"
export * from "./FullPageTermsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports